'use strict';

wbApp.factory('contractSvc', ['$resource', '$q', 'repositorySvc', 'accountingBookSvc',
    function ($resource, $q, repositorySvc, accountingBookSvc) {

        const Contract = $resource('/restapi/contracts/:id', {}, {
            'getById': {method: 'GET', url: '/restapi/contracts/:id'},
            'getAll': {method: 'GET', isArray: true, url: '/restapi/contracts'},
            'insert': {method: 'POST', url: '/restapi/contracts'},
            'update': {method: 'PUT', url: '/restapi/contracts/:id'},
            'delete': {method: 'DELETE', url: '/restapi/contracts/:id'},
            'sendContracts': {method: 'POST', url: '/restapi/contracts/:id/send-contracts-notification'}
        });

        let contracts;

        function createNew()
        {
            return $q(function (resolve, reject) {
                var model = {
                    id: null,
                    isActive: true,
                    contractSchedules: [{}],
                    userId: null,
                    studentId: null
                };

                let dfAccountingBookPromise = accountingBookSvc.getDefaultAsync();
                dfAccountingBookPromise.then(function (acc) {
                    model.accountingBookId = acc.id;
                    resolve(model);
                }, function (err) {
                    reject(err);
                });
            })
        }
        
        function transformModelForSave(model) {
            model.userFullName = null;

            if (!model.contractSchedules || model.contractSchedules.length === 0) {
                model.contractSchedules = [];
            }

            _.forEach(model.contractSchedules, function(schedule) {
                schedule.monday = transformDayModelForSave(schedule.monday);
                schedule.tuesday = transformDayModelForSave(schedule.tuesday);
                schedule.wednesday = transformDayModelForSave(schedule.wednesday);
                schedule.thursday = transformDayModelForSave(schedule.thursday);
                schedule.friday = transformDayModelForSave(schedule.friday);
                schedule.saturday = transformDayModelForSave(schedule.saturday);
                schedule.sunday = transformDayModelForSave(schedule.sunday);
            });
            
            model.contractTemplatesIds = [];
            if (!!model.contractTemplateType0) model.contractTemplatesIds.push(model.contractTemplateType0);
            if (!!model.contractTemplateType1) model.contractTemplatesIds.push(model.contractTemplateType1);
            if (!!model.contractTemplateType2) model.contractTemplatesIds.push(model.contractTemplateType2);
            if (!!model.contractTemplateType3) model.contractTemplatesIds.push(model.contractTemplateType3);
            if (!!model.contractTemplateType4) model.contractTemplatesIds.push(model.contractTemplateType4);
            if (!!model.contractTemplateType6) model.contractTemplatesIds.push(model.contractTemplateType6);
            if (!!model.contractTemplateType7) model.contractTemplatesIds.push(model.contractTemplateType7);

            return model;
        }
        
        function getContractTemplateIdByType(model, contractTemplateType)
        {
            return _.find(model.contractTemplatesInfos, { 'contractTemplateType' : contractTemplateType })?.id;
        }
        
        function transformModelForEdit(model) {
            model.userFullName = '';
            
            if (!model.contractSchedules || model.contractSchedules.length === 0) {
                model.contractSchedules = [];
            }
            
            _.forEach(model.contractSchedules, function(schedule) {
                schedule.monday = transformDayModelForEdit(schedule.monday);
                schedule.tuesday = transformDayModelForEdit(schedule.tuesday);
                schedule.wednesday = transformDayModelForEdit(schedule.wednesday);
                schedule.thursday = transformDayModelForEdit(schedule.thursday);
                schedule.friday = transformDayModelForEdit(schedule.friday);
                schedule.saturday = transformDayModelForEdit(schedule.saturday);
                schedule.sunday = transformDayModelForEdit(schedule.sunday);
            });
            
            if (!model.contractTemplatesInfos) {
                model.contractTemplatesInfos = [];
            }
            model.contractTemplateType0 = _.find(model.contractTemplatesInfos, { 'contractTemplateType' : 0 })?.id;
            model.contractTemplateType1 = _.find(model.contractTemplatesInfos, { 'contractTemplateType' : 1 })?.id;
            model.contractTemplateType2 = _.find(model.contractTemplatesInfos, { 'contractTemplateType' : 2 })?.id;
            model.contractTemplateType3 = _.find(model.contractTemplatesInfos, { 'contractTemplateType' : 3 })?.id;
            model.contractTemplateType4 = _.find(model.contractTemplatesInfos, { 'contractTemplateType' : 4 })?.id;
            model.contractTemplateType6 = _.find(model.contractTemplatesInfos, { 'contractTemplateType' : 6 })?.id;
            model.contractTemplateType7 = _.find(model.contractTemplatesInfos, { 'contractTemplateType' : 7 })?.id;
            
            return model;
        }
        
        function transformDayModelForEdit(dayModel) {
            if (!dayModel) {
                return {
                    active: false,
                    startTime: null,
                    endTime: null,
                    food: false
                };
            } else {
                dayModel.active = true;
                if (!isNaN(dayModel.startTime)) {
                    dayModel.startTime = moment().startOf('day').add(dayModel.startTime, 'minutes').toDate();
                }
                if (!isNaN(dayModel.endTime)) {
                    dayModel.endTime = moment().startOf('day').add(dayModel.endTime, 'minutes').toDate();
                }
            }
            
            return dayModel;
        }

        function transformDayModelForSave(dayModel) {
            if (!dayModel.active) {
                return null;
            } else {
                if (moment(dayModel.startTime).isValid()) {
                    let midnight = moment(dayModel.startTime).startOf('day');
                    dayModel.startTime = moment(dayModel.startTime).diff(midnight, 'minutes')
                } else {
                    dayModel.startTime = null;
                }
                if (moment(dayModel.endTime).isValid()) {
                    let midnight = moment(dayModel.endTime).startOf('day');
                    dayModel.endTime = moment(dayModel.endTime).diff(midnight, 'minutes')
                } else {
                    dayModel.endTime = null;
                }
            }

            return dayModel;
        }   
        
        function sendContracts(contractId, contractTemplateTypes) {
            return repositorySvc.customPostWithParams(
                'sendContracts',
                Contract,
                { id: contractId },
                {
                    contractTemplateTypes: contractTemplateTypes
                });            
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                Contract,
                model);
        }

        function remove(rentCategoryId) {
            contracts = null;
            return repositorySvc.customDelete(
                'delete',
                Contract,
                { id: rentCategoryId });
        }

        function update(model) {
            contracts = null;
            return repositorySvc.customPutWithParams(
                'update',
                Contract,
                { id: model.id },
                convertDatesToDateString(model));
        }

        function getById(id) {
            return repositorySvc.customGet('getById', Contract, { id: id });
        }

        function getAll(refresh) {
            if (!contracts || refresh) {
                contracts = repositorySvc.customGet('getAll', Contract, { 
                    expanded: 'SimplePersonalInfo,ContractTemplatesInfo'
                });
            }
            return contracts;
        }
        
        return {
            createNew: createNew,
            getById: getById,
            getAll: getAll,
            insert: insert,
            remove: remove,
            update: update,
            transformModelForEdit: transformModelForEdit,
            transformModelForSave: transformModelForSave,
            getContractTemplateIdByType: getContractTemplateIdByType,
            sendContracts: sendContracts
        }
    }]);